//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex'

export default {
  props: {
    credit: {
      type: Object,
      required: true
    },
    creditNumber: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    data: []
  }),

  mounted () {
    this.getCreditBoard(this.creditNumber).then(({ data }) => {
      this.data = data
    })
  },

  methods: {
    ...mapActions([
      'getCreditBoard'
    ]),

    getIcon (item) {
      switch (item.status) {
        case 'pending':
          return { name: 'ic-pending' }
        case 'rejected':
          return { name: 'ic-warning', class: 'ic--error' }
        case 'done':
          return { name: 'ic-valid' }
        default:
          return {}
      }
    }
  }
}
